import React, { useEffect, useState } from "react";
import { getUserP2PAds } from "../../../../../store/Actions/P2PActions";
import { connect } from "react-redux";
import { P2PTableHeaderStyle, P2PTableStyle } from "./UserP2P.styled";
import { P, SubHeader } from "../../../../../UI toolkit/Text/Text";
import {
  capitalizeFirstLetter,
  groupActivitiesByDaysOrMonth,
} from "../../../../../utils/specialFunctions";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
import ic_sent_icon from "../../../../../assets/images/ic-sent-coin.svg";
import ic_receive_icon from "../../../../../assets/images/ic-received-coin.svg";
import ic_swapped_coin from "../../../../../assets/images/ic-swapped-coin.svg";
import { Badge } from "../../../../../UI toolkit/Button/Button";
import moment from "moment";
import UserP2PAdModal from "./UserP2PAdModal";
import UpdateAdStatusModal from "./UpdateAdStatusModal";

TimeAgo.addLocale(en);
const timeAgo = new TimeAgo("en-US");

const UserP2PAdsTable = ({ getAds, ads, userId, user }) => {
  const [ad, setAd] = React.useState(null);
  const [updatedAd, setUpdatedAd] = React.useState(null);
  const [openModal, setopenModal] = useState(false);
  const [openUpdateAdStatusModal, setOpenUpdateAdStatusModal] = useState(false);

  useEffect(() => {
    getAds(userId);
  }, [getAds, userId]);

  // Add a callback function to refresh data after updating ad status
  const refreshAdsAfterUpdate = () => {
    getAds(userId); // Re-fetch ads data
    setOpenUpdateAdStatusModal(false); // Close the modal
  };

  const statusKeys = {
    stopped: "broken",
    active: "ongoing",
    completed: "completed",
    pending: "unclaimed",
    paid: "claimed",
  };

  const bgColor = (isActive) => {
    return isActive ? "#D1F7C4" : "#FFDCE5";
    // : status === "completed" || status === "paid"
    // ? "#D1F7C4"
    // : status === "inactive"
    // ? "#FFDCE5"
    // : "";
  };

  const color = (isActive) => {
    return isActive ? "#606060" : "#531423";
    // ? "#606060"
    // : status === "completed" || status === "paid"
    // ? "#606060"
    // : status === "inactive"
    // ? "#531423"
    // : "";
  };

  return (
    <div style={{ overflowX: "auto" }}>
      <P2PTableHeaderStyle className="w-full">
        <tbody className="w-full">
          <tr className="Table-heading -px-1.5">
            <td width="20%" className="pt-4 pb-4"></td>

            <td width="15%" className="pt-4 pb-4">
              <div className="flex justify-center">
                <SubHeader fontSize="12px" color={"#7C8191"} fontWeight="500">
                  AD PRICE
                </SubHeader>
              </div>
            </td>
            <td width="15%" className="pt-4 pb-4">
              <div className="flex justify-center">
                <SubHeader fontSize="12px" color={"#7C8191"} fontWeight="500">
                  QUANTITY
                </SubHeader>
              </div>
            </td>
            <td width="15%" className="pt-4 pb-4">
              <div className="flex justify-center">
                <SubHeader fontSize="12px" color={"#7C8191"} fontWeight="500">
                  USER
                </SubHeader>
              </div>
            </td>

            <td width="35%" className="w-full pt-4 pb-4 pr-6"></td>
          </tr>
        </tbody>
      </P2PTableHeaderStyle>
      {groupActivitiesByDaysOrMonth(ads ? ads : null, "days") &&
        groupActivitiesByDaysOrMonth(ads ? ads : null, "days").map(
          (transactionGroup, idx, arr) => {
            return (
              <P2PTableStyle className="w-full" key={idx}>
                <div>
                  {/* <pre>{JSON.stringify(transactionGroup, null, 2)}</pre> */}
                </div>
                <tbody>
                  <tr>
                    <td colSpan="5">
                      <div className="pt-4 pb-4 px-1.5">
                        <P fontSize="13px" color={"#7C8191"} fontWeight="500">
                          {`${timeAgo.format(
                            new Date(transactionGroup.group)
                          )} — ${new Date(
                            transactionGroup.group
                          ).toDateString()}`}
                        </P>
                      </div>
                    </td>
                  </tr>

                  {transactionGroup.data.map((curr, idx, arr) => {
                    return (
                      <tr
                        className="px-1.5"
                        style={{ borderBottom: "1px solid #EFF0F5" }}
                        key={idx}
                      >
                        <td width="20%" className="pt-4 pb-4 px-1.5">
                          <Badge
                            color={color(curr.is_active)}
                            bg={bgColor(curr.is_active)}
                          >
                            {curr.is_active ? "Active" : "Inactive"}
                          </Badge>
                        </td>
                        <td width="15%">
                          <div className="flex justify-center items-start flex-col">
                            <P
                              fontSize="13px"
                              color={"#374072"}
                              fontWeight="500"
                            >
                              {curr.action === "buy" ? "Buy ad" : "Sell ad"}
                            </P>
                            <P
                              fontSize="13px"
                              color={"#0087B5"}
                              fontWeight="500"
                              className="underline cursor-pointer"
                              onClick={() => {
                                setUpdatedAd(curr);
                                setOpenUpdateAdStatusModal(true);
                              }}
                            >
                              Update
                            </P>
                          </div>
                        </td>
                        <td width="15%">
                          <div className="flex justify-center">
                            <div>
                              <P
                                fontSize="13px"
                                color={"#374072"}
                                fontWeight="500"
                              >
                                {`${
                                  curr.currency === "USDT"
                                    ? "$"
                                    : curr.currrency === "NGN"
                                    ? "₦"
                                    : ""
                                } ${Number(curr.quantity).toFixed(2)}`}
                              </P>
                            </div>
                          </div>
                        </td>
                        <td width="20%">
                          <div className="flex justify-center items-start">
                            <P
                              fontSize="13px"
                              color={"#374072"}
                              fontWeight="500"
                            >
                              {user.email}
                            </P>
                          </div>
                        </td>
                        <td width="15%">
                          <div className="flex justify-center">
                            <div>
                              <P
                                fontSize="10px"
                                color={"#7A809B"}
                                fontWeight="400"
                              >
                                {/* {moment(curr.created_at).format("L")} */}
                                {moment(curr.created_at).format(
                                  "dddd, MMMM D, YYYY"
                                )}
                              </P>
                            </div>
                          </div>
                        </td>
                        <td width="15%" className="pt-4 pb-4 px-1.5">
                          <div className="flex justify-center">
                            <div className="">
                              <P
                                fontSize="13px"
                                color={"#0087B5"}
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setAd(curr);
                                  setopenModal(true);
                                }}
                              >
                                View
                              </P>
                            </div>
                          </div>
                        </td>
                        <td width="20%" className="pt-4 pb-4 px-1.5">
                          <div className="flex justify-center">
                            {/* <Badge
                              color={color(curr.status)}
                              bg={bgColor(curr.status)}
                            >
                              {statusKeys[curr.status]}
                            </Badge> */}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </P2PTableStyle>
            );
          }
        )}

      <div>
        {openModal ? (
          <UserP2PAdModal
            width={"30%"}
            border={"none"}
            closeModalCallback={() => {
              setopenModal(false);
            }}
            ad={ad}
            user={user}
          />
        ) : null}
        {openUpdateAdStatusModal ? (
          <UpdateAdStatusModal
            width={"30%"}
            border={"none"}
            closeModalCallback={() => {
              setOpenUpdateAdStatusModal(false);
              getAds(userId);
            }}
            ad={updatedAd}
            user={user}
          />
        ) : null}
      </div>
      {/* <pre>{JSON.stringify(ads, null, 2)}</pre> */}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.p2p.loading,
    error: state.p2p.error,
    ads: state.p2p.userP2PAds,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAds: (query) => dispatch(getUserP2PAds(query)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserP2PAdsTable);
